import { useMutation, useQuery } from '@tanstack/react-query';
import { generateHookExports } from 'api/generateExports';
import { createCRUDService } from 'api/queryService';
import { formatPayloadIfNeeded } from 'api/utils';
import axios from "../axios";
import { API_CONFIG } from 'services/apiConfig';
import { showToast } from 'services/utils';
import { routeConstants } from 'services/keyConstants';

let baseData = API_CONFIG.FEEDBACK;
const BASE_URL = baseData?.path;
const QUERY_KEY = baseData?.queryKey;

const feedbackService = createCRUDService({
  baseUrl: BASE_URL,
  queryKey: QUERY_KEY,
  custom: {
    getBySubId: (id, subId, options = {}) =>
      useQuery({
        queryKey: [QUERY_KEY, id],
        queryFn: () => axios.get(`${BASE_URL}/${id}/${subId}`).then((res) => res.data),
        enabled: !!id,
        retry: options.retry ?? 1,
      }),
    public: () => {
      return useMutation({
        mutationFn: (payload) => {
          const data = formatPayloadIfNeeded(payload, payload?.isCustomImage ?? false);
          return axios
            .post(`${BASE_URL}/public`, data, {
              headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {},
            })
            .then((res) => res.data);
        },
        onSuccess: (data) => {
          showToast(data);
        },
        onError: (error) => {
          showToast(error?.data);
        },
      });
    },
    createReport: () => {
      return useMutation({
        mutationFn: (payload) => {
          const data = formatPayloadIfNeeded(payload, payload?.isCustomImage ?? false);
          return axios
            .post(`${routeConstants?.CUSTOMER_SERVICE}/create-feedback`, data, {
              headers: data instanceof FormData ? { 'Content-Type': 'multipart/form-data' } : {},
            })
            .then((res) => res.data);
        },
        onSuccess: (data) => {
          showToast(data);
        },
        onError: (error) => {
          showToast(error?.data);
        },
      });
    },
  },
});

export const {
  feedbackList,
  feedbackCreate,
  feedbackCreateReport,
  feedbackGetById,
  feedbackUpdate,
  feedbackUpdateSpecific,
  feedbackDownload,
  feedbackGetBySubId,
  feedbackPublic,
  feedbackDelete,
  feedbackCount,
} = generateHookExports(feedbackService, 'feedback');
